import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'settings',
  size: 'full',
  children: {
    ats: {
      path: 'recruitment',
      children: {
        templates: {
          level: 1,
          path: 'templates',
          children: {
            messageTemplatesId: {
              level: 2,
              path: 'message_templates/:messageTemplateId',
            },
          },
        },
        processes: {
          level: 1,
          path: 'processes',
        },
        candidateData: {
          level: 1,
          path: 'candidate-data',
        },
        integrations: {
          level: 1,
          path: 'integrations',
        },
        factorialAI: {
          level: 1,
          path: 'factorial-ai',
        },
      },
    },
    company_page: {
      path: 'company-page',
    },
    contracts_settings: {
      path: 'contracts-settings',
      children: {
        workingConditions: {
          path: 'working-conditions',
          level: 2,
          children: {
            version: {
              path: ':identifier',
              children: {
                conditions: {
                  path: 'conditions',
                },
                employees: {
                  path: 'employees',
                },
              },
            },
          },
        },
        agreementApprovals: {
          path: 'agreement-approvals',
          level: 2,
        },
      },
    },
    time_categories_settings: {
      path: 'time-categories-settings',
    },
    engagement: {
      path: 'engagement',
    },
    expenses: {
      path: 'expenses',
      children: {
        expensesForms: {
          path: 'expenses-forms',
          level: 2,
          children: {
            fields: {
              path: ':resource_type',
              level: 2,
              children: {
                edit: {
                  path: ':id',
                  level: 2,
                },
                editByIdentifier: {
                  path: 'identifier/:identifier',
                  level: 2,
                },
              },
            },
          },
        },
        rateConfigurations: {
          path: 'rates',
          level: 1,
          children: {
            rateId: {
              path: ':rateId',
              level: 2,
            },
          },
        },
        mileageRates: {
          path: 'mileage-rates',
          level: 1,
          children: {
            rateId: {
              path: ':rateId',
              level: 2,
            },
          },
        },
        perdiemRates: {
          path: 'perdiem-rates',
          level: 1,
        },
        signedInvoices: {
          path: 'signed-invoices',
          size: 'full',
          children: {
            invoiceId: {
              path: ':invoiceId',
              size: 'full',
            },
            exports: {
              path: 'exports',
              size: 'full',
            },
          },
        },
        italyHomologation: {
          path: 'italy-homologation',
          size: 'full',
        },
      },
    },
    procurement: {
      path: 'procurement',
      children: {
        requests: {
          path: 'requests',
        },
        requestType: {
          path: 'request-type',
          children: {
            id: {
              path: ':id',
              children: {
                form: {
                  path: 'form',
                },
                workflows: {
                  path: 'workflows',
                },
              },
            },
          },
        },
        taskForms: {
          path: 'task-forms',
          children: {
            id: {
              path: ':id',
            },
          },
        },
      },
    },
    software: {
      path: 'software',
    },
    competencies: {
      path: 'competencies',
      children: {
        edit: {
          path: ':competencyId/edit',
        },
        create: {
          path: 'create',
        },
      },
    },
    enps: {
      path: 'enps',
    },
    time_tracking: {
      path: 'time-tracking',
      children: {
        settingId: {
          path: ':settingId',
          children: {
            tabId: {
              level: 2,
              path: ':tabId',
            },
            employeesEmployeeIdFaceRecognitionLogs: {
              level: 2,
              path: 'employees/:employeeId/face_recognition/logs',
            },
            breaksSettingsAdd: {
              level: 3,
              path: 'breaks_settings/add',
            },
            breaksSettingsEditBreakId: {
              level: 3,
              path: 'breaks_settings/edit/:breakId',
            },
            timeRanges: {
              level: 3,
              path: 'time_ranges',
            },
          },
        },
      },
    },
    it_management: {
      path: 'it-management',
    },
    it_inventory: {
      path: 'it-inventory',
      children: {
        legalEntities: {
          path: 'legal-entities',
          children: {
            legalEntity: {
              path: ':legalEntityId',
              level: 2,
            },
          },
        },
        documentTemplates: {
          path: 'document-templates',
        },
        general: {
          path: 'general',
        },
      },
    },
    finance: {
      path: 'finance',
      children: {
        costCenters: {
          size: 'full',
          path: 'cost-centers',
          children: {
            list: {
              size: 'full',
              path: 'list',
              children: {
                newCostCenter: {
                  size: 'full',
                  path: 'new-cost-center',
                },
                edit: {
                  size: 'full',
                  path: 'edit/:id',
                },
                import: {
                  size: 'full',
                  path: 'import',
                },
                delete: {
                  size: 'full',
                  path: 'delete/:id',
                },
              },
            },
            people: {
              size: 'full',
              path: 'people',
              children: {
                create: {
                  size: 'full',
                  path: 'create',
                },
                edit: {
                  size: 'full',
                  path: 'edit/:id',
                },
              },
            },
            newCostCenter: {
              size: 'full',
              path: 'new-cost-center',
            },
            delete: {
              size: 'full',
              path: 'delete/:id',
            },
            edit: {
              size: 'full',
              path: 'edit/:id',
            },
            import: {
              size: 'full',
              path: 'import',
            },
            costCenterId: {
              size: 'full',
              level: 2,
              path: ':id',
              children: {
                edit: {
                  size: 'full',
                  path: 'edit',
                },
                delete: {
                  size: 'full',
                  path: 'delete',
                },
              },
            },
            rename: {
              size: 'full',
              path: 'rename/:id',
            },
          },
        },
        dimensions: {
          path: 'dimensions',
          children: {
            dimension: {
              path: ':id',
              children: {
                delete: {
                  path: 'delete',
                },
                edit: {
                  path: 'edit',
                },
                import: {
                  path: 'import',
                },
                values: {
                  path: 'values/:value_id',
                  children: {
                    delete: {
                      path: 'delete',
                    },
                    edit: {
                      path: 'edit',
                    },
                  },
                },
              },
            },
          },
        },
        sales: {
          path: 'sales',
          children: {
            serialSequence: {
              size: 'full',
              path: 'serial-sequence',
            },
          },
        },
        accounts: {
          path: 'accounts',
          size: 'full',
        },
        accounting: {
          path: 'accounting',
          size: 'full',
          children: {
            expenseCategory: {
              path: 'expense-category',
              size: 'full',
            },
            bankAccount: {
              path: 'bank-account',
              size: 'full',
            },
            vendor: {
              path: 'vendor',
              size: 'full',
            },
            taxType: {
              path: 'tax',
              size: 'full',
              children: {
                taxTypeId: {
                  path: ':id',
                  size: 'full',
                },
              },
            },
            defaultConfiguration: {
              path: 'default-configuration',
              size: 'full',
            },
            payrollConcept: {
              path: 'payroll-concept',
              size: 'full',
            },
          },
        },
      },
    },
    financialWorkspace: {
      path: 'financial-workspace',
    },
    employee_onboarding: {
      path: 'employee-onboarding',
    },
    performance_reviews: {
      path: 'performance_v2',
      children: {
        template: {
          level: 2,
          path: 'questions-templates/:questionsTemplateId',
        },
      },
    },
    performanceProcess: {
      path: 'performance_process',
    },
    payroll_bundle: {
      path: 'payroll-bundle',
      children: {
        incidences: {
          level: 2,
          path: 'incidences',
        },
        expensesReimbursement: {
          level: 2,
          path: 'expenses-reimbursement',
        },
        timeReimbursement: {
          path: 'time-reimbursement',
        },
        integrationA3innuva: {
          level: 2,
          path: 'integration_a3innuva',
        },
        integrationA3nom: {
          level: 2,
          path: 'integration_a3nom',
        },
        integrationDatev: {
          level: 2,
          path: 'integration_datev',
        },
        integrationDatevApi: {
          level: 2,
          path: 'integration_datev_api',
        },
        integrationZucchetti: {
          level: 2,
          path: 'integration_zucchetti',
        },
        integrationPaierh: {
          level: 2,
          path: 'integration_paierh',
        },
        integrationYeapPaierh: {
          level: 2,
          path: 'integration_yeap_paierh',
        },
        integrationSilae: {
          level: 2,
          path: 'integration_silae',
        },
        integrationGispaghe: {
          level: 2,
          path: 'integration-gispaghe',
        },
        concepts: {
          level: 2,
          path: 'concepts',
        },
        policies: {
          level: 2,
          path: 'policies/:policyId',
          children: {
            basicInfo: {
              level: 2,
              path: 'basic-info',
            },
            employees: {
              level: 2,
              path: 'employees',
            },
          },
        },
      },
    },
    compensations: {
      path: 'compensations',
      children: {
        payrollConcepts: {
          level: 2,
          path: 'payroll-concepts',
        },
        employeeUpdates: {
          level: 2,
          path: 'employee-updates',
        },
        integrationA3innuva: {
          level: 2,
          path: 'integration_a3innuva',
        },
        integrationA3nom: {
          level: 2,
          path: 'integration_a3nom',
        },
        integrationDatev: {
          level: 2,
          path: 'integration_datev',
        },
        integrationDatevApi: {
          level: 2,
          path: 'integration_datev_api',
        },
        integrationZucchetti: {
          level: 2,
          path: 'integration_zucchetti',
        },
        integrationSage100: {
          level: 2,
          path: 'integration_sage100',
        },
        integrationPaierh: {
          level: 2,
          path: 'integration_paierh',
        },
        integrationYeapPaierh: {
          level: 2,
          path: 'integration_yeap_paierh',
        },
        integrationSilae: {
          level: 2,
          path: 'integration_silae',
        },
        integrationTeamSystem: {
          level: 2,
          path: 'integration_team_system',
        },
        integrationGispaghe: {
          level: 2,
          path: 'integration-gispaghe',
        },
        integrationJobSistemi: {
          level: 2,
          path: 'integration_job_sistemi',
        },
        timeReimbursement: {
          level: 2,
          path: 'time-reimbursement',
        },
        expensesReimbursement: {
          level: 2,
          path: 'expenses-reimbursement',
        },
        benefits: {
          level: 2,
          path: 'benefits',
        },
        cycles: {
          path: 'cycles',
          children: {
            id: {
              path: ':id',
              level: 2,
            },
          },
        },
      },
    },
    benefits: {
      path: 'benefits',
    },
    salaryAdvance: {
      path: 'salary-advance',
    },
    complaints: {
      path: 'complaints',
    },
    surveys: {
      path: 'surveys',
      children: {
        template: {
          level: 2,
          path: 'questions-templates/:questionsTemplateId',
        },
      },
    },
    details: {
      path: 'details',
      children: {
        newClause: {
          path: 'new-clause',
        },
        editClauseId: {
          path: 'edit-clause/:id',
        },
        newLegalEntity: {
          path: 'new-legal-entity',
        },
        removeLegalEntityId: {
          path: 'remove-legal-entity/:id',
        },
      },
    },
    timeoffPolicies: {
      path: 'timeoff-policies',
      children: {
        policies: {
          level: 2,
          path: 'policies',
          children: {
            removeId: {
              path: 'remove/:id',
            },
          },
        },
        absenceTypes: {
          level: 2,
          path: 'absence-types',
        },
        approvalGroups: {
          level: 2,
          path: 'approval-groups',
        },
        blockedPeriods: {
          level: 2,
          path: 'blocked-periods',
        },
        new: {
          path: 'new',
        },
        newLeaveType: {
          path: 'new-leave-type',
        },
        editLeaveTypeId: {
          path: 'edit-leave-type/:id',
        },
        blockedPeriodsId: {
          level: 2,
          path: 'blocked-periods/:id',
        },
        id: {
          level: 2,
          path: ':id',
          children: {
            details: {
              level: 2,
              path: 'details',
              children: {
                addAllowance: {
                  level: 2,
                  path: 'add-allowance',
                },
              },
            },
            allowances: {
              path: 'allowances',
              children: {
                new: {
                  level: 3,
                  path: 'new',
                },
                allowanceId: {
                  level: 3,
                  path: ':allowanceId',
                },
              },
            },
            employees: {
              level: 2,
              path: 'employees',
              children: {
                add: {
                  level: 2,
                  path: 'add',
                },
                moveEmployeeId: {
                  level: 2,
                  path: 'move/:employeeId',
                },
              },
            },
          },
        },
      },
    },
    workSchedule: {
      path: 'work-schedule',
      children: {
        archived: {
          path: 'archived',
        },
        new: {
          path: 'new',
        },
        id: {
          level: 2,
          path: ':id',
          children: {
            edit: {
              level: 2,
              path: 'edit',
              children: {},
            },
            periodNew: {
              level: 2,
              path: 'period/new',
            },
            periodPeriodId: {
              level: 2,
              path: 'period/:periodId',
            },
            archive: {
              path: 'archive',
            },
            employees: {
              level: 2,
              path: 'employees',
              children: {
                add: {
                  level: 2,
                  path: 'add',
                },
              },
            },
          },
        },
      },
    },
    legalEntitiesId: {
      level: 2,
      path: 'legal-entities/:id',
      children: {
        details: {
          path: 'details',
        },
        employeeGroups: {
          path: 'employee-groups',
          children: {
            new: {
              path: 'new',
            },
            employeeGroupId: {
              path: ':employee_group_id',
              children: {
                assign: {
                  path: 'assign',
                },
                edit: {
                  path: 'edit',
                },
                remove: {
                  path: 'remove',
                },
                main: {
                  path: 'main',
                },
              },
            },
          },
        },
        contracts: {
          path: 'contracts',
        },
        timeConditions: {
          path: 'time-conditions',
        },
        taxTypeId: {
          path: 'tax-types/:taxTypeId',
          level: 2,
          children: {
            delete: {
              level: 2,
              path: 'delete',
            },
            edit: {
              level: 2,
              path: 'edit',
            },
            new: {
              level: 2,
              path: 'new',
            },
            editRate: {
              level: 2,
              path: 'rates/:taxRateId/edit',
            },
            deleteRate: {
              level: 2,
              path: 'rates/:taxRateId/delete',
            },
          },
        },
        newTaxType: {
          path: 'tax-types/new',
        },
      },
    },
    locations: {
      path: 'locations',
      children: {
        editId: {
          path: 'edit/:id',
        },
        locationNew: {
          path: 'location/new',
        },
        removeId: {
          path: 'remove/:id',
        },
        locationsId: {
          path: ':id',
          children: {
            workAreasArchived: {
              level: 1,
              path: 'work-areas/archived',
            },
            details: {
              path: 'details',
              level: 2,
            },
            employees: {
              path: 'employees',
              level: 2,
              children: {
                add: {
                  level: 1,
                  path: 'add',
                },
                moveEmployeeId: {
                  level: 1,
                  path: 'move/:employeeId',
                },
              },
            },
            holidays: {
              path: 'holidays',
              level: 2,
              children: {
                add: {
                  level: 2,
                  path: 'add',
                },
                editHolidayId: {
                  level: 2,
                  path: 'edit/:holidayId',
                },
                import: {
                  level: 2,
                  path: 'import',
                },
              },
            },
            workAreas: {
              level: 2,
              path: 'work-areas',
              children: {
                add: {
                  level: 2,
                  path: 'add',
                },
                workAreaIdEdit: {
                  level: 2,
                  path: ':workAreaId/edit',
                },
                addWorkSpace: {
                  level: 2,
                  path: ':workAreaId/work-space/add',
                },
                editWorkSpace: {
                  level: 2,
                  path: ':workAreaId/work-space/:workSpaceId/edit',
                },
                workSpaces: {
                  level: 2,
                  path: ':workAreaId/work-spaces',
                  children: {
                    addWorkSpace: {
                      level: 2,
                      path: 'add',
                    },
                    editWorkSpace: {
                      level: 2,
                      path: ':workSpaceId/edit',
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
    plans: {
      path: 'plans',
      children: {
        expenses: {
          path: 'expenses',
        },
        upgrade: {
          path: 'upgrade',
        },
      },
    },
    folders: {
      path: 'folders',
      children: {
        employees: {
          path: 'employees',
          children: {
            new: {
              path: 'new',
            },
            remove: {
              path: 'remove/:id',
            },
            show: {
              path: ':id',
              children: {
                new: {
                  path: 'new',
                },
              },
            },
          },
        },
        internal: {
          path: 'internal',
          children: {
            new: {
              path: 'new',
            },
            remove: {
              path: 'remove/:id',
            },
            show: {
              path: ':id',
              children: {
                new: {
                  path: 'new',
                },
              },
            },
          },
        },
        public: {
          path: 'public',
          children: {
            new: {
              path: 'new',
            },
            remove: {
              path: 'remove/:id',
            },
            show: {
              path: ':id',
              children: {
                new: {
                  path: 'new',
                },
              },
            },
          },
        },
        customFields: {
          path: 'customFields',
        },
      },
    },
    customizations: {
      path: 'customizations',
      children: {
        customTablesId: {
          path: 'custom-tables/:id',
          children: {
            destroy: {
              path: 'destroy',
            },
          },
        },
      },
    },
    permissions: {
      path: 'permissions',
      children: {
        id: {
          path: ':id',
          level: 2,
          children: {
            delegate: {
              level: 2,
              path: 'delegate',
            },
            visibility: {
              level: 2,
              path: 'visibility',
            },
            accessLevels: {
              level: 2,
              path: 'access-levels',
              children: {
                accessLevelId: {
                  level: 2,
                  path: ':accessLevelId',
                  children: {
                    permissions: {
                      level: 2,
                      path: 'permissions',
                    },
                  },
                },
              },
            },
            employees: {
              level: 2,
              path: 'employees',
              children: {
                userIdAssign: {
                  level: 2,
                  path: ':userId/assign',
                },
              },
            },
            externals: {
              level: 2,
              path: 'externals',
              children: {
                userIdAssign: {
                  level: 2,
                  path: ':userId/assign',
                },
              },
            },
          },
        },
      },
    },
    externals: {
      path: 'externals',
    },
    auditLog: {
      path: 'audit-log',
      size: 'full',
    },
    automations: {
      path: 'automations',
      children: {
        list: {
          size: 'full',
          path: 'list',
          children: {
            new: {
              path: 'new',
            },
          },
        },
        id: {
          size: 'full',
          path: ':id',
          children: {
            details: {
              size: 'full',
              path: 'details',
              children: {
                rename: {
                  path: 'rename',
                },
                editDate: {
                  path: 'edit-date',
                },
                delete: {
                  path: 'delete',
                },
                addBlockParentId: {
                  path: 'add-block/:parentId',
                },
                actionsActionIdDelete: {
                  path: 'actions/:action_id/delete',
                },
              },
            },
            history: {
              size: 'full',
              path: 'history',
              children: {
                delete: {
                  path: 'delete',
                },
                rename: {
                  path: 'rename',
                },
              },
            },
          },
        },
      },
    },
    apiKeys: {
      path: 'api-keys',
    },
    approvalGroupsCategoryId: {
      path: 'approval-groups/:category/:id',
      children: {
        rulesConfigurations: {
          path: 'rules-configuration',
          children: {
            new: {
              path: 'new',
            },
            edit: {
              path: ':rules_configuration_id',
            },
          },
        },
        employees: {
          path: 'employees',
          children: {
            add: {
              path: 'add',
            },
          },
        },
        details: {
          path: 'details',
        },
      },
    },
    referralProgram: {
      path: 'referral-program',
    },
    trainings: {
      path: 'trainings',
      children: {
        global: {
          path: 'global',
        },
      },
    },
    security: {
      path: 'security',
      children: {
        bulkEmailChange: {
          path: 'bulk-email-change',
          size: 'full',
        },
      },
    },
    universalImporter: {
      path: 'import-history',
      children: {
        universalImporterProcess: {
          path: ':importProcessId/*',
        },
      },
    },
  },
} as const satisfies Location
